import React from "react";
import { useParams } from "react-router";
import Branding from "@pages/dashboard/certification/branding";
import Common from "@pages/dashboard/certification/common/index";
import NotFound from "@pages/not-found/index";
const index: React.FC = () => {
  const params = useParams();
  let { type } = params;
  switch (type) {
    case "certificates":
      return <Common />;
    case "manage-template":
      return <Common />;
    case "branding":
      return <Branding />;
    default:
      return <NotFound />;
  }
};

export default index;
